// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"349":"6049960e","365":"6049960e"}[chunkId] + ".chunk.css");